import { Outlet } from "react-router-dom";
import AdminMobileHeader from "./AdminMobileHeader";
import AdminMobileBottomTabs from "./AdminMobileBottomTabs";
import ImpersonationBanner from "@/components/ImpersonationBanner";
import EnvironmentBanner from "@/components/EnvironmentBanner";

export default function AdminMobileAppShell() {
  return (
    <div className="min-h-screen bg-background flex flex-col" style={{ paddingTop: "var(--env-banner-height, 0px)" }}>
      <EnvironmentBanner />
      <ImpersonationBanner />
      <AdminMobileHeader />
      <main className="flex-1 px-4 py-4 pb-20 content-glow-bg relative z-10">
        <Outlet />
      </main>
      <AdminMobileBottomTabs />
    </div>
  );
}
